import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { RichtwertEinheit } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/richtwertEinheit';
import { Heading, RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function RichtwertEinheit() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 items-center">
        <Heading>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.description',
          )}
        </Heading>
      </div>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit"
        listeners={{
          onChange: () => {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <RadioGroup
              className="flex flex-row"
              value={field.state.value}
              onValueChange={(val) =>
                field.handleChange(val as RichtwertEinheit)
              }>
              <RadioGroupItem
                value="euro"
                variant="card"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.euro',
                )}
              />
              <RadioGroupItem
                value="stunden"
                variant="card"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.stunden',
                )}
              />
              <RadioGroupItem
                value="exakt"
                variant="card"
                label={t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.exakt',
                )}
              />
            </RadioGroup>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
